import axios from 'axios';
import moment from 'moment';

import * as actions from './actionsTypes';
import messages from "../../messages";
import ScheduleTrackingPlannedVacationsEmployeeServices from './scheduleTrackingPlannedVacationsEmployee.service';
import CalendarEmployeeServices from '../calendar_employee_events/calendar.services';
export const getScheduleTrackingPlannedVacationsEmployee = (params) => async (dispatch) => {
  try {
    dispatch({
      type: actions.IS_LOADING_FETCH_SCHEDULE,
      payload: true,
    });
    
    const resp = await ScheduleTrackingPlannedVacationsEmployeeServices.getScheduleTrackingPlannedVacationsEmployees(params);
    const { empleados, eventos_empleados } = resp.data;
    for (let i = 0; i < eventos_empleados.length; i++) {
      eventos_empleados[i].start_time = moment(eventos_empleados[i].start_time);
      eventos_empleados[i].end_time = moment(eventos_empleados[i].end_time);
    }
    dispatch({
      type: actions.GET_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE,
      payload: { empleados, eventos_empleados },
    });
    dispatch({
      type: actions.FAILURE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 401:
            window.location.href = "/";
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAILURE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.IS_LOADING_FETCH_SCHEDULE,
      payload: false,
    });
  }
};

export const updateScheduleTrackingPlannedVacationsEmployee = (id, data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.IS_LOADING_FETCH_SCHEDULE,
      payload: true,
    });
    await CalendarEmployeeServices.updateCalendarUserEvent(id, data);
    const { empleados, eventos_empleados  } = getState().scheduleTrackingPlannedVacationsEmployee.scheludeTrackingPlannedVacationsEmployee;
    const index = eventos_empleados.findIndex((event) => event.id === id);
    if (index !== -1) {
      eventos_empleados[index].end_time = moment(data.end_time);
    }
    dispatch({
      type: actions.UPDATE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE,
      payload: { empleados, eventos_empleados },
    });
    dispatch({
      type: actions.FAILURE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 401:
            window.location.href = "/";
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAILURE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.IS_LOADING_FETCH_SCHEDULE,
      payload: false,
    });
  }
}